// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"023caaf7","256":"78617384","286":"43f2d4be"}[chunkId] + ".chunk.css";
};